import { useEffect, useRef, useState } from 'react'
import { useLanguage } from '@/shared/lib/i18n/use-language'
import { DOM_EVENT } from '@/shared/constants/keyboard'
import { LANGUAGE } from '@/shared/constants/language'

export function useLanguageSwitcher() {
  const { currentLanguage, toggleLanguage, switchLabel } = useLanguage()
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const isEnglish = currentLanguage === LANGUAGE.EN
  const languages = [
    { code: LANGUAGE.EN, label: isEnglish ? 'English' : 'Inglés' },
    { code: LANGUAGE.ES, label: isEnglish ? 'Spanish' : 'Español' },
  ]

  useEffect(() => {
    if (!isOpen) return
    function handleClickOutside(e: MouseEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        closeDropdown()
      }
    }
    document.addEventListener(DOM_EVENT.MOUSEDOWN, handleClickOutside)
    return () =>
      document.removeEventListener(DOM_EVENT.MOUSEDOWN, handleClickOutside)
  }, [isOpen])

  function toggleDropdown() {
    setIsOpen((prev) => !prev)
  }

  function selectLanguage(code: string) {
    if (code !== currentLanguage) toggleLanguage()
    setIsOpen(false)
  }

  function closeDropdown() {
    setIsOpen(false)
  }

  return {
    currentLanguage,
    toggleLanguage,
    switchLabel,
    isOpen,
    toggleDropdown,
    selectLanguage,
    closeDropdown,
    languages,
    containerRef,
  }
}
